// services/events.service.js
const API_BASE = 'https://api.jobeng.ai';

class EventsService {
  // Fetch all events from the working endpoint
  async getEvents(companyId = 1) {
    try {
      const response = await fetch(`${API_BASE}/api/data/company_events?company_id=${companyId}`);
      const result = await response.json();

      if (result.success && result.data) {
        // The API returns events in the `data` array.
        return this.formatEvents(result.data);
      }
      console.warn('API response format unexpected:', result);
      return [];
    } catch (error) {
      console.error('Error fetching events:', error);
      return [];
    }
  }

  // Format the API data to match your component's expected structure
  formatEvents(apiEvents) {
    return apiEvents.map(event => ({
      id: event.id,
      event_id: event.event_id,
      title: event.title,
      description: event.description,
      event_type: event.event_type,
      start_date: event.start_date,
      end_date: event.end_date,
      location_name: event.location_name,
      location_city: event.location_city,
      organizer_name: event.organizer_name,
      max_attendees: event.max_attendees,
      // Use the pre-calculated field from the database
      registered_count: event.current_attendees,
      is_full: event.max_attendees ? event.current_attendees >= event.max_attendees : false,
      banner_image_url: event.banner_image_url,
      registration_required: event.registration_required,
      registration_deadline: event.registration_deadline,
      status: event.status,
    }));
  }

  // Get a single event by its ID
  async getEventById(eventId) {
    try {
      const response = await fetch(`${API_BASE}/api/data/company_events/${eventId}`);
      const result = await response.json();
      if (result.success && result.data) {
        return this.formatEvents([result.data])[0];
      }
      return null;
    } catch (error) {
      console.error('Error fetching event details:', error);
      return null;
    }
  }
}

export default new EventsService();